import { render, staticRenderFns } from "./AudienceCTA.vue?vue&type=template&id=12055a97&scoped=true"
import script from "./AudienceCTA.vue?vue&type=script&lang=js"
export * from "./AudienceCTA.vue?vue&type=script&lang=js"
import style0 from "./AudienceCTA.vue?vue&type=style&index=0&id=12055a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12055a97",
  null
  
)

export default component.exports